import SceneProperties from "../data/SceneProperties";

function Normalise(dim:number, onHorizontal:boolean) :number {
    if (onHorizontal){
        //normalise on horizontal
        const BASE = 1128;
        return dim * ((document.body.clientWidth * SceneProperties.totalWidthFact) / BASE);
    } else {
        //normalise on vertical
        const BASE = 884;
        return dim * ((window.innerHeight) / BASE);
    }
}

export default Normalise
